"use strict";

exports.__esModule = true;
exports.default = void 0;

require("./style.css");

var _default = 'morpheus-ui-z-index';
exports.default = _default;